import { IFaena } from './Report';
import { getColorCompany } from './Colors';
import moment from 'moment';
import 'moment/locale/es';
import { EReport } from '../Actions/Report/Actions';
import { ReactElement } from 'react';
import { formatAmount } from '../Utils/NumberFormat';

moment.locale('es');

console.log('Locale: ' + moment.locale());

export interface IFaena {
	dcRutProductor: string;
	dcSucursal: string;
	dgNombre: string;
	dgNombreProductor: string;
}

export class Branch {
	public name: string = '';
	public id: number = -1;
	public total: number = 0;
	public qualities: Summary[] = [];
	public list: any[] = [];
	private indexQuality: any = {};
	public addQuality(item: any) {
		this.list.push(item);
		const amount = SummaryProducer.getAmount(item);
		let currentQuality: any = undefined;
		const quality = (item.dgCalidadCobre || item.dgCarga).trim();
		if (quality.toLowerCase() in this.indexQuality) {
			const index = this.indexQuality[quality.toLowerCase()].pos;
			currentQuality = this.qualities[index];
		} else {
			currentQuality = new Summary();
			currentQuality.name = quality;
			currentQuality.details = [];
			this.qualities.push(currentQuality);
			this.indexQuality[quality.toLowerCase()] = {
				pos: this.qualities.length - 1
			};
		}
		currentQuality.total += amount;
	}
}

export class Producer {
	public id: string = '';
	public name: string = '';
	public branchs: Branch[] = [];
	public summary: SummaryProducer = new SummaryProducer();
	public loading: boolean = true;
	public color: string = '';

	private static createProducer(data: IFaena) {
		const res = new Producer();
		res.id = data.dcRutProductor || (data as any).dcRut;
		res.name = data.dgNombreProductor;
		res.branchs.push(this.createBranch(data));
		return res;
	}

	private static createBranch(data: IFaena) {
		const res = new Branch();
		res.name = data.dgNombre;
		res.id = parseInt(data.dcSucursal, 10);
		return res;
	}

	public static transform(
		data: IFaena[],
		id: number,
		fetch: (id: number, idProducer: string) => void,
		dispact: any,
		includeSummary: boolean = true
	): Producer[] {
		const res: Producer[] = [];
		const index = {} as any;
		let currentProducer: Producer | undefined = undefined;
		for (let i = 0; i < data.length; i += 1) {
			const item = data[i];
			const rut = item.dcRutProductor || (item as any).dcRut;
			if (rut in index) {
				currentProducer = res[index[rut].pos];
				(currentProducer as Producer).branchs.push(this.createBranch(item));
			} else {
				currentProducer = this.createProducer(item);
				currentProducer.color = getColorCompany(res.length);
				if (includeSummary) {
					dispact(fetch(id, currentProducer.id));
				}
				res.push(currentProducer);
				index[rut] = {
					pos: res.length - 1
				};
			}
		}
		return res;
	}
}

export interface IError {
	Status: string;
	Descripcion: string;
}

export interface ISummaryPort {
	dcCorrelativoSucursal: string;
	dcRutProductor: string;
	dgCalidadCobre: string;
	dgEstadoCarga: string;
	dgNombre: string;
	dnPesoBruto: string;
}

export class Detail {
	public name: string = '';
	public total: number = 0;
}

export class Summary {
	public name: string = '';
	public color: string = '';
	public details?: Detail[] = [];
	public detailsBrute?: any[] = [];
	public total: number = 0;
}

export class SummaryProducer {
	public idProducer: string = '';
	public branchs: Branch[] = [];
	public status: Summary[] = [];
	public quality: Summary[] = [];
	public total: number = 0;

	public static getAmount(data: any) {
		if (data.dnPesoBruto) {
			return parseFloat(data.dnPesoBruto.replace(',', '.'));
		}
		if (data.dcReservaOut) {
			return parseFloat(data.dcReservaOut.replace(',', '.'));
		}
		if (data.dnStockPesoBruto) {
			return parseFloat(data.dnStockPesoBruto.replace(',', '.'));
		}
		if (data.dcTonelaje) {
			return parseFloat(data.dcTonelaje.replace(',', '.'));
		}
		return -1;
	}

	public static transform(data: ISummaryPort[] | IAnnouncedShipmentResponse[]) {
		const res = new SummaryProducer();
		const indexBranch = {} as any;
		const indexStatus = {} as any;
		const indexQuality = {} as any;
		let currentBranch: Branch | undefined = undefined;
		let currentStatus: Summary | undefined = undefined;
		let currentQuality: Summary | undefined = undefined;
		for (let i = 0; i < data.length; i += 1) {
			try {
				const item = data[i] as ISummaryPort;
				const itemShipment = data[i] as IAnnouncedShipmentResponse;
				const amount = this.getAmount(item);
				res.total += amount;

				if (item.dcCorrelativoSucursal in indexBranch) {
					const index = indexBranch[item.dcCorrelativoSucursal].pos;
					currentBranch = res.branchs[index];
				} else {
					currentBranch = new Branch();
					currentBranch.name = item.dgNombre;
					currentBranch.id = parseInt(item.dcCorrelativoSucursal, 10);
					res.branchs.push(currentBranch);
					indexBranch[item.dcCorrelativoSucursal] = {
						pos: res.branchs.length - 1
					};
				}
				currentBranch.addQuality(item);
				currentBranch.total += amount;
				const status = item.dgEstadoCarga || '';
				if (status.trim().toLowerCase() in indexStatus) {
					const index = indexStatus[status.trim().toLowerCase()].pos;
					currentStatus = res.status[index];
				} else {
					currentStatus = new Summary();
					currentStatus.name = status.trim();
					currentStatus.details = [];
					res.status.push(currentStatus);
					indexStatus[status.trim().toLowerCase()] = {
						pos: res.status.length - 1
					};
				}
				currentStatus.total += amount;
				const detailStatus = new Detail();
				detailStatus.name = item.dgEstadoCarga;
				detailStatus.total = amount;
				currentStatus.details!.push(detailStatus);
				currentStatus.detailsBrute!.push(item);
				const quality = (item.dgCalidadCobre || itemShipment.dgCarga).trim();
				if (quality.toLowerCase() in indexQuality) {
					const index = indexQuality[quality.toLowerCase()].pos;
					currentQuality = res.quality[index];
				} else {
					currentQuality = new Summary();
					currentQuality.name = quality;
					currentQuality.details = [];
					res.quality.push(currentQuality);
					indexQuality[quality.toLowerCase()] = {
						pos: res.quality.length - 1
					};
				}
				currentQuality.total += amount;
				const detailQuality = new Detail();
				detailQuality.name = item.dgCalidadCobre;
				detailQuality.total = amount;
				currentQuality.details!.push(detailQuality);
			} catch (e) {
				console.log(e);
			}
		}
		return res;
	}
}

export interface IAnnouncedShipmentResponse {
	dcCarga: string;
	dcCorrelativoSucursal: string;
	dcGuiadeDespacho: string;
	dcResolucion: string;
	dcRutProductor: string;
	dgCarga: string;
	dgNombre: string;
	dgNombreProductor: string;
	dnPesoBruto: string;
	tipo_Transporte: string;
}

export interface IShipmentResponse {
	dcAño: string;
	dcCarga: string;
	dcMes: string;
	dcTipoCarga: string;
	dcTonelaje: string;
	dgCarga: string;
	dgNave: string;
}

export class ShipmentDateDetail {
	public date: moment.Moment;
	public consolidate: number = 0;
	public breakBulk: number = 0;
	constructor(date: moment.Moment) {
		this.date = date;
	}

	public sum(type: string, amount: number) {
		if (type && type.length > 0) {
			if (
				type
					.trim()
					.toLowerCase()
					.indexOf('consolidada') < 0
			) {
				this.breakBulk += amount;
			} else {
				this.consolidate += amount;
			}
		}
	}
}

export class ShipmentSummary {
	public shipments: Shipment[] = [];
	public total: number = 0;
	public list: IShipmentResponse[] = [];
	public details: ShipmentDateDetail[] = [];
	private _indexShipment: any = {};
	private _indexDates: any = {};

	public static create(data: IShipmentResponse[]) {
		const res = new ShipmentSummary();
		try {
			for (let i = 0; i < data.length; i += 1) {
				const item = data[i];
				res.add(item);
			}
		} catch (e) {
			console.log(e);
		}
		return res;
	}

	public add(data: IShipmentResponse) {
		this.list.push(data);
		if (data.dcTipoCarga) {
			const cat = data.dcTipoCarga.trim();
			const total = parseFloat(data.dcTonelaje.replace(',', '.'));
			let currentShipment: Shipment = new Shipment(cat);
			if (cat.toLowerCase() in this._indexShipment) {
				delete currentShipment.category;
				const index = this._indexShipment[cat.toLowerCase()].pos;
				currentShipment = this.shipments[index];
			} else {
				this._indexShipment[cat.toLowerCase()] = {
					pos: this.shipments.length
				};
				this.shipments.push(currentShipment);
			}
			currentShipment.add(data.dcAño, data.dcMes, data.dgCarga, total);
			this.total += total;
			currentShipment.total += total;
			this.addDate(data.dcAño, data.dcMes, total, cat);
		}
	}

	public addDate(year: string, month: string, amount: number, type: string) {
		const dateMonth = `${year}-${month.padStart(2, '0')}`;
		const date = moment(`${dateMonth}-01T00:00:00`);
		let currentDate = new ShipmentDateDetail(date);
		amount = amount / 1000 / 1000;
		if (dateMonth in this._indexDates) {
			const index = this._indexDates[dateMonth].pos;
			delete currentDate.date;
			currentDate = this.details[index];
		} else {
			this._indexDates[dateMonth] = {
				pos: this.details.length
			};
			this.details.push(currentDate);
		}
		currentDate.sum(type, amount);
	}
}

export class Shipment {
	public category: string = '';
	public total: number = 0;
	public dates: ShipmentDate[] = [];
	public status: ShipmentStatus[] = [];
	private _indexDates = {} as any;
	private _indexStatus = {} as any;
	constructor(category: string = '') {
		this.category = category;
	}

	public addDate(year: string, month: string, amount: number) {
		const dateMonth = `${year}-${month.padEnd(2, '0')}`;
		const date = moment(`${dateMonth}-01T00:00:00`);
		let currentDate = new ShipmentDate(date);
		if (dateMonth in this._indexDates) {
			const index = this._indexDates[dateMonth].pos;
			delete currentDate.date;
			currentDate = this.dates[index];
		} else {
			currentDate.year = parseInt(year);
			currentDate.month = parseInt(month);
			this._indexDates[dateMonth] = {
				pos: this.dates.length
			};
			this.dates.push(currentDate);
		}
		currentDate.total += amount;
	}

	public add(year: string, month: string, status: string, amount: number) {
		this.addDate(year, month, amount);

		let currentStatus = new ShipmentStatus(status);
		if (status.trim().toLowerCase() in this._indexStatus) {
			const index = this._indexStatus[status.trim().toLowerCase()].pos;
			delete currentStatus.name;
			currentStatus = this.status[index];
		} else {
			this._indexStatus[status.trim().toLowerCase()] = {
				pos: this.status.length
			};
			this.status.push(currentStatus);
		}
		currentStatus.addDate(year, month, amount);
		currentStatus.total += amount;
	}
}

export class ShipmentDate {
	public year: number = -1;
	public month: number = -1;
	public date: moment.Moment;
	public total: number = 0;

	constructor(date: moment.Moment) {
		this.date = date;
	}
}

export class ShipmentStatus {
	public name: string = '';
	public total: number = 0;
	public dates: ShipmentDate[] = [];
	private _indexDates = {} as any;

	constructor(status: string) {
		this.name = status;
	}

	public addDate(year: string, month: string, amount: number) {
		const dateMonth = `${year}-${month.padStart(2, '0')}`;
		const date = moment(`${dateMonth}-01T00:00:00`);
		let currentDate = new ShipmentDate(date);
		if (dateMonth in this._indexDates) {
			const index = this._indexDates[dateMonth].pos;
			delete currentDate.date;
			currentDate = this.dates[index];
		} else {
			currentDate.year = parseInt(year);
			currentDate.month = parseInt(month);
			this._indexDates[dateMonth] = {
				pos: this.dates.length
			};
			this.dates.push(currentDate);
		}
		currentDate.total += amount;
	}
}

export interface IDescriptor {
	field: string;
	label: string;
	transform?: (value: any) => ReactElement;
}

export interface ICardHistoryItem {
	data: any;
	descriptor: IDescriptor;
}

export interface ICardData {
	title: ICardHistoryItem;
	content: ICardHistoryItem[];
	fieldSearch: string;
	icon?: ReactElement;
}

const amountTransform = (value: any) => {
	return (`${formatAmount(value)} Kton`);
}

export const getScheme = (report: EReport) => {
	let scheme: any = undefined;
	switch (report) {
		case EReport.Announced:
			scheme = {
				title: 'dcGuiadeDespacho',
				titleLabel: 'N° Guía de Despacho',
				icon: true,
				fields: {
					dnPesoBruto: 'Toneladas',
					dgCarga: 'Calidad',
					dcResolucion: 'Resolución de acopio',
					tipo_Transporte: 'Tipo de Transporte'
				},
				transforms: {
					dnPesoBruto: amountTransform
				}
			};
			break;
		case EReport.Yard:
			scheme = {
				title: 'dfIngreso',
				titleLabel: 'Fecha de Ingreso',
				fields: {
					dgCarga: 'Calidad',
					dnPesoBruto: 'Toneladas'
				},
				transforms: {
					dnPesoBruto: amountTransform
				}
			};
			break;
		case EReport.Bath:
			scheme = {
				title: 'dcCorrelativoNaveViaje',
				titleLabel: 'Correlativo Viaje',
				fields: {
					dnPesoBruto: 'Toneladas Brutas',
					dnPesoNeto: 'Toneladas Netas',
					dcCorrelativoNaveViaje: 'Correlativo Viaje',
					dgCarga: 'Calidad',
					dgMarca: 'Marca',
					dgNave: 'Nave',
					dgTipoCarga: 'Tipo de Carga'
				},
				transforms: {
					dnPesoBruto: amountTransform
				}
			};
			break;
		case EReport.Stacking:
			scheme = {
				title: 'dcReservaOut',
				titleLabel: 'N° de Reserva',
				fields: {
					dcReservaOut: 'N° de Reserva',
					dcTonelaje: 'Toneladas',
					dgCarga: 'Calidad',
					dgMarca: 'Marca',
					dgNaveOut: 'Nave',
					dcPtoDes: 'Destino',
					dfFechaHoraZarpe: 'Día y hora de zarpe'
				},
				transforms: {
					dcTonelaje: amountTransform
				}
			};
			break;
		case EReport.BreakBulk:
			scheme = {
				title: 'dcReserva',
				titleLabel: 'N° de Reserva',
				fields: {
					dcReserva: 'N° de Reserva',
					dcTonelaje: 'Toneladas',
					dgCarga: 'Calidad',
					dgMarca: 'Marca',
					dgNave: 'Nave',
					dcPuertoDescarga: 'Destino',
					dfFechaHoraZarpe: 'Día y hora de zarpe'
				},
				transforms: {
					dcTonelaje: amountTransform
				}
			};
			break;
		case EReport.Consolidate:
			scheme = {
				title: 'dcReserva',
				titleLabel: 'N° de Reserva',
				fields: {
					dcReserva: 'N° de Reserva',
					dnStockPesoBruto: 'Toneladas',
					dgCarga: 'Calidad',
					dgMarca: 'Marca',
					dgNave: 'Nave',
					dcDestinoFinal: 'Destino',
					dnStockPaquetes: 'Cantidad de Contenedores',
					dfFechaHoraZarpe: 'Día y hora de zarpe'
				},
				transforms: {
					dnStockPesoBruto: amountTransform
				}
			};
			break;
	}
	return scheme;
}

export const createMapData = (data: any[], report: EReport) => {
	const res: ICardData[] = [];
	const scheme = getScheme(report);
	for (let i = 0; i < data.length; i += 1) {
		const item = data[i];
		const dataItem: ICardData = {
			fieldSearch: scheme.title,
			title: {
				data: item,
				descriptor: {
					field: scheme.title,
					label:  scheme.titleLabel
				}
			},
			content: Object.keys(scheme.fields).map(k => ({
				data: item,
				descriptor: {
					field: k,
					label: scheme.fields[k],
					transform: scheme.transforms[k]
				}
			}))
		};
		res.push(dataItem);
	}
	return res;
};
